// extracted by mini-css-extract-plugin
export default {"container":"EditEntity_container__X5pvn","header":"EditEntity_header__uMpXT","body":"EditEntity_body__ZdDI2"};